export { default as DummyWelcomePageEndpoint } from './DummyWelcomePageEndpoint';
export { default as DummyPrivatePageEndpoint } from './DummyPrivatePageEndpoint';
export { default as StandardApplicationEntrypoint } from './StandardApplicationEntrypoint';
export { default as ApplicationListEndpoint } from './ApplicationListEndpoint';
export { default as EventApplicationEntrypoint } from './EventApplicationEntrypoint';
export { default as CustomerListEndpoint } from './CustomerListEndpoint';
export { default as ConfiguratorApplicationEntrypoint } from './ConfiguratorApplicationEntrypoint';
export { default as MobilityApplicationEntrypoint } from './MobilityApplicationEntrypoint';
export { default as WebPageEndpoint } from './WebPageEndpoint';
export { default as StandardApplicationPublicAccessEntrypoint } from './StandardApplicationPublicAccessEntrypoint';
export { default as FinderApplicationPublicAccessEntrypoint } from './FinderApplicationPublicAccessEntrypoint';
export { default as FinderApplicationEntrypoint } from './FinderApplicationEntrypoint';
